<template>
	<popup ref="popup" :loading="popupLoading">
		<div slot="body">
			<el-form class="dataForm" ref="form" :disabled="disabled" :model="formParameter" :inline="true"
				label-width="80px" :rules="rules">
				<el-row>
					<el-col :span="24">
						<el-form-item label="日期" prop="kqdate">
							<el-date-picker v-model="formParameter.kqdate" type="date" placeholder="选择日期"
								value-format="yyyy-MM-dd"></el-date-picker></el-form-item>
					</el-col>
				</el-row>
				<!-- <el-row>
						<el-col :span="24">
							<el-form-item label="状态： 0待确认,1,有反馈，2，已确认" prop="state"><el-input v-model="formParameter.state" autocomplete="off"></el-input></el-form-item>
						</el-col>
					</el-row> -->
				<el-row>
					<el-col :span="24">
						<el-form-item label="反馈" prop="feedback">
							<el-input type="textarea" v-model="formParameter.feedback"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="原因状态" prop="result">
							<el-radio v-model="formParameter.result" label="迟到">迟到</el-radio>
							<el-radio v-model="formParameter.result" label="早退">早退</el-radio>
							<el-radio v-model="formParameter.result" label="请假">请假</el-radio>
							<el-radio v-model="formParameter.result" label="缺勤">缺勤</el-radio>
							<el-radio v-model="formParameter.result" label="正常">正常</el-radio></el-form-item>
					</el-col>
				</el-row>
			</el-form>
		</div>
		<div slot="footer">
			<el-button v-if="!disabled" type="primary" :loading="confirmLoading" @click="confirm()">确
				定</el-button>
			<el-button @click="close">取 消</el-button>
		</div>
	</popup>
</template>

<script>
import popup from '@/components/popup/drawerPopup.vue';
import api from '@/api/oa/teacherAttendance.js';
export default {
	name: 'edit',
	components: {
		popup
	},
	data() {
		return {
			disabled: false,
			popupLoading: false,
			confirmLoading: false,
			parameter: {},
			formParameter: {},
			rules: {
				//教师id
				tid: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					},
					{
						validator: this.$validate.length,
						max: 32,
						trigger: 'blur'
					}
				],
				//日期
				kqdate: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					}
				],
				//主管反馈
				feedback: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					},
					{
						validator: this.$validate.length,
						max: 255,
						trigger: 'blur'
					}
				],
				//结果:迟到、早退、请假，病假，正常
				result: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					},
					{
						validator: this.$validate.length,
						max: 20,
						trigger: 'blur'
					}
				],

			}
		};
	},
	methods: {
		//打开弹框
		open(parameter, title, disabled, size) {
			this.parameter = parameter;
			this.disabled = disabled;
			this.$refs.popup.open(title, size);
			this.$nextTick(() => {
				this.init();
			})
		},
		//关闭弹框
		close() {
			this.disabled = false;
			this.$refs.popup.close();
		},
		//提交表单
		confirm() {
			this.formParameter.state = 1;

			this.$utils.checkForm(this.$refs.form, () => {
				let parameter = this.$utils.merger(this.formParameter);
				api.repair(parameter,
					response => {
						this.$utils.msg.success(response.msg);
						this.confirmLoading = false;
						this.close();
						this.$parent.list();
					},
					response => {
						this.$utils.msg.warning(response.msg);
						this.confirmLoading = false;
					}
				);
			});
		},
		init() {
			this.popupLoading = true;
			//清除等待
			this.confirmLoading = false;
			//清空内容
			this.formParameter = {};
			this.popupLoading = false;
			//清楚校验
			this.$refs.form.clearValidate();
			//获取当前的用户id
			if (this.parameter.tid) {
				this.formParameter.tid = this.parameter.tid
			} else {
				let userinfo = sessionStorage.getItem("user");
				userinfo = JSON.parse(userinfo);
				this.formParameter.tid = userinfo.id;
			}

		}
	}
};
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
@import '~common/custom/css/popup/popup.scss';
</style>
